export const authRoutes = {
  login: {
    path: '/connexion',
    name: 'login',
    component: () => import('@/components/pages/auth/LoginPage.vue'),
    meta: { requireAuth: false }
  },
  forgotPassword: {
    path: '/mot-de-passe-oublie',
    name: 'forgotPassword',
    component: () => import('@/components/pages/auth/ForgotPasswordPage.vue'),
    meta: { requireAuth: false }
  },
  forgotPasswordConfirmation: {
    path: '/mot-de-passe-oublie/confirmation',
    name: 'forgotPasswordConfirmation',
    component: () => import('@/components/pages/auth/ForgotPasswordConfirmationPage.vue'),
    meta: { requireAuth: false }
  },
  resetPassword: {
    path: '/mot-de-passe-oublie/reinitialisation',
    name: 'resetPassword',
    component: () => import('@/components/pages/auth/ResetPasswordPage.vue'),
    meta: { requireAuth: false }
  },
  resetPasswordConfirmtion: {
    path: '/mot-de-passe-oublie/reinitialisation/confirmation',
    name: 'resetPasswordConfirmation',
    component: () => import('@/components/pages/auth/ResetPasswordConfirmationPage.vue'),
    meta: { requireAuth: true }
  },
  resetPasswordInvalid: {
    path: '/mot-de-passe-oublie/lien-invalide',
    name: 'resetPasswordInvalid',
    component: () => import('@/components/pages/auth/ResetPasswordInvalidPage.vue'),
    meta: { requireAuth: false }
  },
  emailConfirmation: {
    path: '/inscription/confirmation-email',
    name: 'email-confirmation',
    component: () => import('@/components/pages/auth/EmailConfirmationPage.vue'),
    meta: { requireAuth: false }
  },
  emailConfirmationSuccess: {
    path: '/inscription/confirmation-email/valide',
    name: 'email-confirmation-success',
    component: () => import('@/components/pages/auth/EmailConfirmationSuccessPage.vue'),
    meta: { requireAuth: false }
  }
};
